var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAi = function SvgIconAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.968 12H12v-.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.26V0h-.002C5.371.001 0 5.373 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.786L8.474 6.261z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07 1.565a12.06 12.06 0 0 0-4.506 4.506V12h3.13V4.696H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 10.525 7.735 6.26H6.26l5.739 5.74z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M20.294 13.757a2.93 2.93 0 0 0 .576-1.756V6.783a2.605 2.605 0 0 1-3.652-.522 2.605 2.605 0 0 1-3.653.522v5.218c0 .702.23 1.282.576 1.756z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF9811"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.208 11.032c.166-.405.295-.998.295-1.292 0-.474-.617-.858-.617-.858s-.618.384-.618.858c0 .294.13.887.296 1.292l-.357.805a1.8 1.8 0 0 0 1.358 0zM16.796 8.427c-.434.059-1.012.243-1.267.39-.41.237-.434.964-.434.964s.641.343 1.051.106c.256-.148.704-.556.972-.902l.875-.094a1.8 1.8 0 0 0-.679-1.175zM15.745 11.82c.267.347.716.755.971.902.41.237 1.052-.105 1.052-.105s-.024-.727-.434-.964c-.256-.148-.833-.332-1.267-.39l-.52-.712a1.8 1.8 0 0 0-.678 1.176z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M14.012 13.566c.974 1.563 3.206 2.086 3.206 2.086s2.23-.523 3.205-2.086z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconAi;